import { useQuery } from "@tanstack/react-query";
import Link from "next/link";

import Layout from "../components/layouts/layout.comp";
import { ListSection, Tag } from "../components/reuseables/list.comp";
import shelfCore from "../core/shelf.core";
import { useTranslation } from "../core/translation.core";
import ErrorCenterIcon from "../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../icons/loadingOvalCenter.icon";
import PencilIcon from "../icons/pencil.icon";
import { Shelf } from "../types/shelf";
import AddLink from "../components/form/addLink.comp";

export default function ShelvesPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.shelf.shelf)} titleBtn={<AddLink id="shelf-create" href="/shelf/create" />}>
      <ListSection>
        <List />
      </ListSection>
    </Layout>
  );
}

const List = () => {
  const { t, msg } = useTranslation();
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["shelves"],
    queryFn: shelfCore.listShelves,
  });

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  return (
    <div id="shelf-list" className="pt-6 lg:pt-0">
      <div className="hidden lg:grid lg:grid-cols-[6fr_3fr_2fr] gap-6 px-6 py-3 text-sm font-medium">
        <div>{t(msg.shelf.name)}</div>
        <div></div>
      </div>

      {data!.map((a) => (
        <Row key={a.id} shelf={a} />
      ))}
    </div>
  );
};

function Row({ shelf }: { shelf: Shelf }) {
  const { t, msg } = useTranslation();

  return (
    <div className="shelf-row grid grid-cols-2 lg:grid-cols-[6fr_3fr_2fr] gap-x-6 gap-y-3 px-6 py-6 border-t-[1px] text-sm group/edit">
      <div data-value={shelf.name}>
        <Tag>{t(msg.shelf.name)}</Tag>
        <p>{shelf.name}</p>
      </div>
      <div className="col-span-2 lg:col-span-1">
        <Link className="shelf-edit cursor-pointer" href={`/shelf/edit/${shelf.id}`}>
          <PencilIcon className="w-4 h-4 text-her-robinEggBlue" />
        </Link>
      </div>
    </div>
  );
}
